import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_o_filter.svg'
import _imports_1 from '@/app/ui/assets/svg/ics_o_filter_red.svg'
import _imports_2 from '@/app/ui/assets/svg/ics_o_search.svg'
import _imports_3 from '@/app/ui/assets/svg/ics_o_contactNote.svg'
import _imports_4 from '@/app/ui/assets/svg/chevron-up-light.svg'


const _hoisted_1 = {
  id: "filter-wrapper",
  class: "w-full"
}
const _hoisted_2 = { class: "flex flex-row items-start gap-3" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "text-sm font-semibold" }, "Filter", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  class: "absolute top-4 right-4",
  src: _imports_2,
  alt: "search"
}, null, -1)
const _hoisted_5 = { class: "text-sm font-semibold" }
const _hoisted_6 = { class: "w-full text-gray-lp-300" }
const _hoisted_7 = { class: "flex flex-row justify-between items-center border-b border-gray-lp-400 px-4 py-2" }
const _hoisted_8 = /*#__PURE__*/_createVNode("img", {
  src: _imports_4,
  class: "w-4 h-4"
}, null, -1)
const _hoisted_9 = { class: "px-4 py-2 border-b border-gray-lp-400" }
const _hoisted_10 = {
  class: "px-4 py-2",
  style: {"height":"81px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_MultipleSelectSearch = _resolveComponent("MultipleSelectSearch")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("section", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("button", {
          id: "filter-client-btn",
          class: ["flex flex-row items-center gap-2 p-4 py-2.5 rounded-md w-auto flex-shrink-0", [
          _ctx.isFilterOpen ? 'border-gray-lp-600' : '',
          _ctx.isDisabled
            ? 'text-gray-lp-600 cursor-not-allowed bg-gray-lp-1500'
            : 'border-gray-lp-2100',
          'border'
        ]],
          style: {"min-width":"95px"},
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openFilter && _ctx.openFilter(...args))),
          disabled: _ctx.isDisabled,
          ref: "filterClientButton"
        }, [
          (!_ctx.filterValues.length)
            ? (_openBlock(), _createBlock("img", {
                key: 0,
                src: _imports_0,
                class: { 'text-gray-lp-600 opacity-60': _ctx.isDisabled }
              }, null, 2))
            : (_openBlock(), _createBlock("img", {
                key: 1,
                src: _imports_1,
                class: { 'text-gray-lp-600 opacity-60': _ctx.isDisabled }
              }, null, 2)),
          _hoisted_3
        ], 10, ["disabled"]),
        (!_ctx.showButtonOpenList)
          ? (_openBlock(), _createBlock(_component_LpInput, {
              key: 0,
              id: "filter-client-input-search",
              class: "filter-client-input-search",
              placeholder: _ctx.$t('bookingV3.filterClient.list.searchPlaceholder'),
              modelValue: _ctx.clientSearchValueModel,
              "onUpdate:modelValue": [
                _cache[2] || (_cache[2] = ($event: any) => (_ctx.clientSearchValueModel = $event)),
                _ctx.fetchClientsDebounced
              ],
              onFocus: _ctx.setDirty,
              disabled: _ctx.isDisabled,
              disableBackground: _ctx.isDisabled
            }, {
              suffix: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }, 8, ["placeholder", "modelValue", "onUpdate:modelValue", "onFocus", "disabled", "disableBackground"]))
          : (_openBlock(), _createBlock(_component_SelectSearch, {
              key: 1,
              class: { 'filter-client-select': !!_ctx.clientOptions.length },
              placeholder: _ctx.$t('bookingV3.filterClient.clientPlaceholder'),
              modelValue: _ctx.clientValueModel,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.clientValueModel = $event)),
              maxHeight: "193px",
              useInfiniteScroll: "",
              options: _ctx.clientOptions,
              isLoading: _ctx.clientLoading,
              keyName: "label",
              keyValue: "value",
              isShowErrorIndicator: !!_ctx.error.client,
              errorCaption: _ctx.error.client,
              onFilter: _ctx.fetchClientsDebounced,
              onFocus: _ctx.fetchClients,
              onScrolled: _ctx.fetchClientsInfiniteScroll,
              isDisabled: _ctx.isDisabled,
              disabledBackground: _ctx.isDisabled
            }, null, 8, ["class", "placeholder", "modelValue", "options", "isLoading", "isShowErrorIndicator", "errorCaption", "onFilter", "onFocus", "onScrolled", "isDisabled", "disabledBackground"])),
        (_ctx.showButtonOpenList)
          ? (_openBlock(), _createBlock("button", {
              key: 2,
              id: "filter-client-open-list-btn",
              class: ["flex flex-row items-center gap-2 p-4 py-2.5 rounded-md w-auto flex-shrink-0", [
          _ctx.isDisabled
            ? 'text-gray-lp-600 cursor-not-allowed bg-gray-lp-1500'
            : 'border-gray-lp-2100',
          'border'
        ]],
              style: {"min-width":"140px"},
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('open-list'))),
              disabled: _ctx.isDisabled
            }, [
              _createVNode("img", {
                src: _imports_3,
                alt: "contact-note",
                class: { 'text-gray-lp-600 opacity-60': _ctx.isDisabled }
              }, null, 2),
              _createVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("bookingV3.filterClient.list.title")), 1)
            ], 10, ["disabled"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_OverlayPanel, {
      ref: "op",
      style: _ctx.tooltipStyle,
      class: "client-filter-op",
      id: "client-filter-op"
    }, {
      default: _withCtx(() => [
        _createVNode("section", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            _createTextVNode(_toDisplayString(_ctx.$t("bookingV3.filterClient.filter.title")) + " ", 1),
            _hoisted_8
          ]),
          _createVNode("div", _hoisted_9, [
            _createVNode(_component_DataWrapper, {
              id: "filter-client-select-wrapper",
              label: _ctx.$t('bookingV3.filterClient.filter.originLabel')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_SelectSearch, {
                  class: { 'filter-client-select': !!_ctx.cityOptions.length },
                  placeholder: _ctx.$t('bookingV3.filterClient.filter.originPlaceholder'),
                  useInfiniteScroll: "",
                  maxHeight: "214px",
                  modelValue: _ctx.originValueModel,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.originValueModel = $event)),
                  options: _ctx.cityOptions,
                  isLoading: _ctx.originLoading,
                  onFocus: _ctx.fetchOrigins,
                  onFilter: _ctx.fetchOriginsDebounced,
                  onScrolled: _ctx.fetchOriginsInfiniteScroll,
                  onChange: _ctx.onChangeFilter,
                  onEsc: _ctx.onEscFilter
                }, null, 8, ["class", "placeholder", "modelValue", "options", "isLoading", "onFocus", "onFilter", "onScrolled", "onChange", "onEsc"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _createVNode("div", _hoisted_10, [
            _createVNode(_component_DataWrapper, {
              id: "filter-client-select-wrapper",
              label: _ctx.$t('bookingV3.filterClient.filter.serviceTypeLabel')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_MultipleSelectSearch, {
                  id: "filter-client-select",
                  placeholder: 
              _ctx.$t('bookingV3.filterClient.filter.serviceTypePlaceholder')
            ,
                  modelValue: _ctx.deliveryServiceValuesModel,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.deliveryServiceValuesModel = $event)),
                  options: _ctx.deliveryServiceOptions,
                  onChange: _ctx.onChangeFilter
                }, null, 8, ["placeholder", "modelValue", "options", "onChange"])
              ]),
              _: 1
            }, 8, ["label"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["style"])
  ], 64))
}